<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1> <i class="fa-sharp-duotone fa-regular fa-notes"></i> Grupo {{ form.name }}
                    <RouterLink style="float:right; position:relative; top:-10px;" to="/dashboard" class="btn btn-primary"> <i class="fa-light fa-arrow-turn-down-left"></i> Voltar</RouterLink>
                </h1>
                <hr />
                 <div class="cont">
                    <Loading v-if="exibeLoading" />
                    <form @submit.prevent="handleProjetos">
                    <!-- Etapa 1 --> 
                        <div v-if="step === 1">
                            <div class="form-group mb-3">
                            <input type="text"  v-model="form.name" disabled placeholder="Nome da Classe" class="form-control" required />
                            </div>

                            <div class="form-group mb-3">
                            <label class="mt-2">Selecione a recuperanda</label>
                            <select v-model="form.id_recuperanda" disabled style="height:50px;" class="form-control mt-2" required>
                                <option v-for="reck in dadosRecuperanda" :key="reck.id" :value="reck.id">{{ reck.name }}</option>
                            </select>
                        </div>

                            <button type="button" class="btn btn-primary" @click="nextStep">Próximo</button>
                        </div>

                        <!-- Etapa 2 -->
                        <div v-if="step === 2">

                            <div class="form-group mb-2">
                                <label>Nome do Credor</label>
                            <input type="text" v-model="credor" placeholder="Nome do credor" class="form-control" required />

                            <div class="form-group mb-3">
                                <label class="mt-4">Selecione a Classe do credor</label>
                                <select v-model="id_classe_" style="height:50px;" @change="verificaSubFilhos(id_classe_)" class="form-control mt-2" required>
                                    <option v-for="reck in dadosClasses" :key="reck.id" :value="reck.id">{{ reck.name }} </option>
                                </select>
                            </div>
                            <div v-if="exibeFilhos" class="form-group mb-3">
                                <label class="mt-1">Selecione a subClasse</label>
                                <select v-model="id_subclasse_" style="height:50px;" class="form-control mt-2" required>
                                    <option v-for="reck in dadosFilhos" :key="reck.id" :value="reck.id">{{ reck.name }} </option>
                                </select>
                            </div>

                            <button @click="handleCredor" class="mt-3 btn btn-secondary"  type="button">Adicionar</button>
                            </div>
                            <!-- <button type="button" class="btn btn-secondary me-2 mt-4" @click="prevStep">Voltar</button>
                            <button v-if="dadosCredores.length > 0" type="button" class="btn btn-primary mt-4" @click="nextStep">Próximo</button> -->
                            
                            <div v-if="dadosCredores.length > 0" class="col-md-12 mt-4">
                                <h4>Lista de credores  <button v-if="!exibe" type="text" @click="voltar()" class="btn btn-primary"> <i class="fa-light fa-arrow-turn-down-left"></i> Voltar</button>                                </h4>
                                <hr>
                                <table v-if="exibe" class="table">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Classe do Credor</th>
                                        <th>Parcelas</th>
                                        <th>Remover</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="reck in dadosCredores" :key="reck.id">
                                        <td>
                                            <ul>
                                                <li v-for="credor in reck.credor" :key="credor.id">{{ credor.name }}</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul>
                                                <li v-for="credor in reck.credor" :key="credor.id">{{ credor.classe.name }}</li>
                                            </ul>
                                        </td>
                                        <td><i  style="cursor: pointer;" @click="credorUnico(reck.id_credor)" class="fa-light fa-money-bill-simple-wave"></i></td>
                                        <td>
                                            <!-- Aqui você pode colocar o botão para remover, se necessário -->
                                            <i style="cursor: pointer;" class="fa-light fa-trash" @click="removerCredor(reck.id_credor, rota)"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                            <div v-if="!exibe" class="container">
                            <div class="col-md-12" style="box-shadow:1px 2px 3px rgba(0,0,0,.5); padding:20px; border-radius:10px;">
                                <div class="row">
                                    <h1> Credor <b>{{ nomeCredor.name }}</b></h1>
                                    <hr></hr>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label>Quantas parcelas?</label>
                                                <select style="height: 55px;" v-model="quantidadeParcelas" class="form-control" required>
                                                    <option v-for="reckParcelas in parcelas" :value="reckParcelas" :key="reckParcelas.id">{{reckParcelas}}x</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label>Início da parcela?</label>
                                                    <input type="date" v-model="inicioParcela" class="form-control" required>
                                            </div>
                                            <div class="col-md-3">
                                                <label>Valor das parcelas?</label>
                                                    <input type="text" v-model="reckValor" v-money="moneyMask" placeholder="R$ 200,00"  class="form-control" required>
                                            </div>
                                            <div class="col-md-3">
                                                <label>Tipo de Parcela?</label>
                                                <select v-model="tipo_parcela" style="height: 55px !important;" class="form-control" required>
                                                    <option value="mensal">Mensal</option>
                                                    <option value="trimestral">Trimestral</option>
                                                    <option value="semestral">Semestral</option>
                                                    <option value="anual">Anual</option>
                                                    <option value="bianual">Bianual</option>
                                                </select>
                                            </div>
                                            <hr class="mt-3"></hr>

                                            <div class="col-md-3">
                                                <label>% Deságio</label>
                                                    <input type="text" v-model="desagio" placeholder="%"  class="form-control" required>
                                            </div>

                                            <div class="col-md-3">
                                                <label>Carência</label>
                                                    <input type="text" v-model="carencia"  class="form-control" required>
                                            </div>

                                            <div class="col-md-3">
                                                <label>Homologação</label>
                                                    <input type="date" v-model="homologacao"  class="form-control" required>
                                            </div>

                                            <div class="col-md-3">
                                                <label>Tipo de Taxa</label>
                                                    <input type="text" v-model="taxa"  class="form-control" required>
                                            </div>

                                            <div class="col-md-3">
                                                <label>Valor Original</label>
                                                    <input type="text" v-model="reckValorOriginal"  v-money="moneyMask" placeholder="R$ 200,00"  class="form-control" required>
                                            </div>


                                            <button @click="gerarParcelas(nomeCredor.id)" style="width:200px;" type="button" class="btn btn-primary mt-3">Gerar Parcelas</button>
                                        </div>
                                    </div>
                                    <table class="table mt-5">
                                        <thead>
                                            <tr>
                                                <th>Vencimento</th>
                                                <th>Valor</th>
                                                <th>Situação</th>
                                                <th>Remover</th>
                                                <th>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="dadosFaturas.length > 0">
                                            <tr v-for="reck in dadosFaturas" :key="reck.id">
                                                <td>{{ handleData(reck.inicio_parcela)  }}</td>
                                                <td>R$ {{reck.valor_parcela }}</td>
                                                <td v-html="reck.situacao == 2 ? '<div class=\'alert alert-warning\'>Pendente</div>' : '<div class=\'alert alert-success\'>Pago</div>'"></td>
                                                <td v-if="reck.situacao != 1"><i  @click="remover_fatura(reck.id, nomeCredor.id)" style="cursor: pointer;" class="fa-light fa-trash"></i></td>
                                                <td v-if="reck.situacao != 1"><button v-if="situacao != 1" @click="faturaPaga(reck.id, nomeCredor.id)" class="btn btn-primary" type="button">Marcar como pago</button></td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else >
                                            <tr>
                                                <div class="alert alert-warning mt-4">Nenhuma fatura disponível</div>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                            </div>
                        </div>
                            </div>
                        </div>
                        <!-- Etapa 3 -->
                        <div v-if="step === 3">
                            <div class="form-group mb-3">
                            <input type="email"  placeholder="Email do Responsável" class="form-control" required />
                            </div>
                            <button type="button" class="btn btn-secondary me-2" @click="prevStep">Voltar</button>
                            <button type="submit" class="btn btn-success">Finalizar Cadastro</button>
                        </div>
                    </form>
                    <Alert style="margin-top:20px;" v-if="exibeAlert" :tipo="tipoS" :msg="msgS" />
            </div>
            </div>
        </div>
    </div>
    </template>

<script setup>
import { ref, onMounted } from 'vue';
import Menu from '@/components/Menu.vue';
import { mask } from 'vue-the-mask';
import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';
import projetos from '@/servicos/projetos';
import classes from '@/servicos/classes';
import recuperanda from '@/servicos/recuperanda';
import { routeLocationKey, useRoute } from 'vue-router';
import moment, { months } from 'moment';
import Swal from 'sweetalert2';


const exibe = ref(true)
const nome = ref('')
const exibeAlert = ref(false)
const tipoS = ref('')
const msgS = ref('')
const exibeLoading = ref(false)
const step = ref(2);
const rotas = useRoute()
const rota = ref(rotas.params.id)
const dadosRecuperanda = ref([])
const dadosClasses = ref([])
const credor = ref('')
const dadosCredores = ref([])
const tipo_parcela = ref('');

/********************* Parcelas a serem pagas **************** */
const parcelas = ref([]);
const nomeCredor = ref('')
const quantidadeParcelas = ref([]);
const inicioParcela = ref('')
const reckValor = ref();
const dadosFaturas = ref([])
const reckValorOriginal = ref();
const carencia = ref('');
const homologacao = ref('');
const desagio = ref('')
const taxa = ref('')
const exibeFilhos = ref(false);
const dadosFilhos = ref([])

const id_classe_ = ref('')
const id_subclasse_ = ref('')

const credorUnico = async (id_credor) => {
    exibe.value = false
    nomeCredor.value = ''
    const response = await projetos.credorUnico(id_credor)
    nomeCredor.value = response.data
    dadosFaturas.value = []
    buscaFaturas(id_credor)
}

const voltar = () => {
    exibe.value = true
}

const verificaSubFilhos =  async (value) => {
    const response = await classes.filhos(value)
    dadosFilhos.value =  response.data

    if(dadosFilhos.value.length > 0) {
        exibeFilhos.value = true
    }
}


const remover_fatura = async (value, id_credor) => {
    if(window.confirm("Deseja realmente excluir essa parcela?")){
        const response = await projetos.deletar_fatura(value)
        dadosFaturas.value = []
        buscaFaturas(id_credor)
    }
}
const removerCredor = async (id, id_credor) => {
    const result = await Swal.fire({
        title: "Opa!",
        text: "Deseja realmente remover esse credor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: 'Não remover',
        confirmButtonText: "Sim, remover"
    });

    if (result.isConfirmed) {
        try {
            await projetos.remove_credor(id, id_credor);
            await buscaCredores();
            await Swal.fire({
                title: "Removido",
                text: "O credor foi removido com sucesso.",
                icon: "success"
            });
        } catch (error) {
            Swal.fire({
                title: "Erro!",
                text: "Não foi possível remover o credor.",
                icon: "error"
            });
        }
    }
};


const faturaPaga = async (value, id_credor) => {

    const {value: data_pagamento} =  await Swal.fire({
        title: "Qual o Mês de pagamento?",
        input: "month",
        icon: "question"
    })

    if(data_pagamento){
        const {value: valor_pagamento }= await Swal.fire({
            title: "Qual o valor pago?",
            input: "text",
            icon: "question",
            inputAttributes: {
                "v-money": moneyMask 
            }
        })

        const confirm = await Swal.fire({
            title: "Deseja realmente confirmar o pagamento?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: 'Cancelar',
            confirmButtonText: "Sim, Confirmar"
        })

        if(confirm.isConfirmed){
                const response = await projetos.fatura_paga(value, data_pagamento, valor_pagamento)
                dadosFaturas.value = []
                buscaFaturas(id_credor)
                Swal.fire({
                    title: "Sucesso",
                    text: "Parcela confirmada com sucesso",
                    icon: "success",
                    confirmButtonText: "Ok"
                })
        }
    }
}

const gerarParcelas = async (id_credor) => {

    if(reckValor.value === 'R$ 0,00'){
        Swal.fire({
            title: "Ops",
            icon: "error",
            text: "O valor da parcela não pode ser inferior a  0 ou vázio",
            confirmButtonText: "Ok"
        })
    }



    // if(reckValor.value < 0 || reckValor.value === ''){
    // }

    const response = await projetos.gerarFaturas(id_credor, quantidadeParcelas.value, inicioParcela.value, reckValor.value, rotas.params.id, reckValorOriginal.value, 
        carencia.value, homologacao.value, desagio.value, taxa.value, tipo_parcela.value
    )
    quantidadeParcelas.value = ''
    inicioParcela.value = ''
    reckValor.value = ''
    reckValorOriginal.value =''
    carencia.value = ''
    homologacao.value = ''
    desagio.value = ''
    taxa.value = ''
    buscaFaturas(id_credor)
}

const buscaFaturas = async (id_credor) => {
    dadosFaturas.value = []
    const response = await projetos.buscar_faturas(id_credor, rotas.params.id)
    dadosFaturas.value = response.data
}
/********************* Fim parcelas a serem pagas **************** */


const handleData = (value) => {
    return moment(value).format('DD/MM/YYYY')
}


const valorParcela = ref('')

const exibeParcelas = () => {
    for (let i = 1; i <= 48; i++) {
        parcelas.value =  i
    }
};
const form = ref({
    name: "",
    id_classe: "",
    id_recuperanda: "",
    id_subclasse:  ""
})

const handleCredor = async () => {
    if(credor.value === ''){
        Swal.fire({
            title: 'Ops!',
            text: 'Digite o nome do credor antes de confirmar',
            icon: 'error',
            confirmButtonText: 'Ok'
            })
        return
    }

    if(id_classe_.value === '' || id_classe_.value === null){
        Swal.fire({
            title: "Ops",
            text: "Escolha a classe para o credor",
            icon: "error",
            confirmButtonText: "Ok"
        })
        return
    }

    const response = await projetos.cadastrar_credores(credor.value, id_classe_.value, id_subclasse_.value, rotas.params.id) 
    credor.value = ''
    id_classe_.value = ''
    id_subclasse_.value = ''
    buscaCredores() 
    Swal.fire({
            title: 'Sucesso',
            text: 'Credor adiciondo com sucesso',
            icon: 'success',
            confirmButtonText: 'Ok'
            })
}

const buscaProjeto = async () => {
    const response = await projetos.show(rotas.params.id)
    form.value.name = response.data.name
    form.value.id_classe = response.data.id_classe
    form.value.id_recuperanda = response.data.id_recuperanda
}

const moneyMask =  {
      prefix: 'R$ ',
      thousands: '.',
      decimal: ',',
      precision: 2,
      masked: false
    };


const buscaCredores = async () => {
    const response = await projetos.busca_credores(rotas.params.id)
    dadosCredores.value = response.data
}

const buscaRecuperanda = async () => {
    const response = await recuperanda.getAll();
    dadosRecuperanda.value = response.data
}

const buscaClasses = async () => {
    const response = await classes.getAll("todos");
    dadosClasses.value = response.data
}

const nextStep = () => {
  if (step.value < 3) step.value++;
};

const prevStep = () => {
  if (step.value > 1) step.value--;
};

const handleProjetos = async () => {
    exibeLoading.value = true
    const response = await classes.create(nome.value)

    if(response.data.response){
        exibeAlert.value = true
        tipoS.value = 'danger',
        msgS.value = response.response.data.message
        exibeLoading.value = false
    }

    if(response.data.id){
        exibeAlert.value = true
        tipoS.value = 'success',
        msgS.value = "Classe cadastrada com sucesso"
        nome.value = ''
        exibeLoading.value = false
    }

}

onMounted(() => {
    buscaProjeto()
    buscaRecuperanda()
    buscaClasses()
    buscaCredores()
    exibeParcelas()
})

</script>


    <style>
    ul li { list-style: none;}
    h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important;}
    /* .table>:not(caption)>*>* { background-color:#1B3639;  } */
    th {color:rgba(255,255,255,.9) !important; padding:10px !important;}
    th { background-color: #1B3639 !important;}
    .cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }
    
    </style>